import { AcadBaseDocument } from "@framework/models";

export default class ScholarshipRequirement extends AcadBaseDocument {
  static readonly PATH: string = "scholarshipRequirements";
  id: string = "";
  name: string = "";
}
